import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SocialIconItem from './SocialIconItem';

const SocialIconList = ({ icons, onUpdate, onDelete }) => {
  if (icons.length === 0) {
    return (
      <div className="text-center py-12 bg-[#1a1a3e] border border-gray-800 rounded-xl">
        <p className="text-gray-500">No social icons added yet</p>
        <p className="text-gray-600 text-sm mt-2">Add your first icon using the form above</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <AnimatePresence>
        {icons.map((icon) => (
          <SocialIconItem
            key={icon.id}
            icon={icon}
            onUpdate={onUpdate}
            onDelete={onDelete}
          />
        ))}
      </AnimatePresence>
    </div>
  );
};

export default SocialIconList;
